import type { HTMLAttributes, ReactNode } from 'react'

interface PanelProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

/** Glass card: the base surface used across the editor. */
export function Panel({ children, className = '', ...rest }: PanelProps) {
  return (
    <div
      className={`bg-ink-surface/90 backdrop-blur-glass border border-ink-border rounded shadow-glass ${className}`}
      {...rest}
    >
      {children}
    </div>
  )
}
